export enum PricingMethod {
  PER_100G = 1,
  SIZE_WISE = 2,
}

export const PRODUCT_TYPE = {
  SIZE: 1,
  VARIANT: 2,
} as const;

export const VARIANT_TYPE = {
  SINGLE: 1,
  DOUBLE: 2,
} as const;

export const ORDER_STATUS = {
  PENDING: 0,
  ACCEPTED: 1,
  PREPARING: 2,
  READY_FOR_PICK_UP: 3,
  PICKED_UP: 4,
  ON_THE_WAY: 5,
  DELIVERED: 6,
  CANCELLED_BY_USER: 7,
  CANCELLED_BY_STORE: 8,
} as const;

export const LOYALTY_TYPE = {
  PURCHASE: 1,
  REVIEW: 2,
  REFER: 3,
  SIGN_UP: 4,
} as const;

export const PAYMENT_STATUS = {
  PENDING: 1,
  PROCESSING: 2,
  COMPLETED: 3,
  CANCELLED: 4,
  FAILED: 5,
} as const;

export const PAYMENT_MODE = {
  CASH: 1,
  ONLINE: 2,
} as const;

export const DELIVERY_OPTION = {
  DELIVERY: 1,
  PICKUP: 2,
} as const;

export const GENDER = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
} as const;

export const USER_TYPES = {
  USER: 1,
  DISPATCHER: 2,
  ADMIN: 3,
  SUBADMIN: 4,
  GUEST: 5,
  DRIVER: 6,
  STORE_MANAGER: 7,
} as const;

